/**
* @file 战队-排行榜
* @author 余凯
*/

import React from 'react'
import { Table, Tabs, Form } from 'antd'
import { connect } from 'react-redux'
import moment from 'moment';

import './index.less'
import 'moment/locale/zh-cn';
import Actions from '@/apis/team'

moment.locale('zh-cn');
const { TabPane } = Tabs

const prestigeColumns = [
  {
    title: '名次',
    dataIndex: 'key',
  },
  // {
  //   title: '用户ID',
  //   dataIndex: 'age',
  // },
  {
    title: '用户昵称',
    dataIndex: 'nickname',
  },
  {
    title: '威望值',
    dataIndex: 'prestige',
  },
  {
    title: '入队时间',
    dataIndex: 'join_time',
  },
];
const buildColumns = [
  {
    title: '名次',
    dataIndex: 'key',
  },
  // {
  //   title: '用户ID',
  //   dataIndex: 'age',
  // },
  {
    title: '用户昵称',
    dataIndex: 'nickname',
  },
  {
    title: '建设值',
    dataIndex: 'donate_wealth_times',
  },
  {
    title: '入队时间',
    dataIndex: 'join_time',
  },
];

@Form.create()
@connect(
  state => state.teamReducer,

)
class Leaderboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buildList: [],
      buildRank: '',
      prestigeList: [],
      prestigeRank: ''
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const startDate = values.date ? values.date[0].format('YYYY-MM-DD') : null
        const endDate = values.date ? values.date[1].format('YYYY-MM-DD') : null
      }
    });
  };

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    Actions.getTeamRank({
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      type: 1,
      page_size: 10
    }).then(res => {
      if (res.code == 200) {
        this.setState({
          prestigeList: res.data.list.map((v, i) => ({ ...v, key: i + 1 })),
          prestigeRank: res.data.rankNumber
        })
      }
    })

    Actions.getTeamRank({
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      type: 2,
      page_size: 10
    }).then(res => {
      if (res.code == 200) {
        this.setState({
          buildList: res.data.list.map((v, i) => ({ ...v, key: i + 1 })),
          buildRank: res.data.rankNumber
        })
      }
    })
  }

  render() {
    const { prestigeList, buildList, prestigeRank, buildRank } = this.state;
    return (
      <div className="team_results">

        <Tabs animated type="card">
          <TabPane tab="威望榜" key="1">
            <Table
              // bordered
              title={() => '我的名次：' + prestigeRank + '名'}
              size="small"
              locale={{
                emptyText: '暂无数据'
              }}
              columns={prestigeColumns}
              dataSource={prestigeList}
              pagination={false}
            // scroll={{"y": 240}}
            />
          </TabPane>
          <TabPane tab="建设榜" key="2">
            <Table
              // bordered
              title={() => '我的名次：' + buildRank + '名'}
              size="small"
              columns={buildColumns}
              dataSource={buildList}
              pagination={false}
            // scroll={{"y": 240}}
            />
          </TabPane>
        </Tabs>

      </div>
    );
  }
}

export default Leaderboard;
